(function () {
  const countSelector = '[data-ca-cart-count]';
  const triggerSelector = '[data-ca-cart-trigger]';

  const setCount = (count) => {
    if (count == null || Number.isNaN(Number(count))) return;
    document.querySelectorAll(countSelector).forEach((node) => {
      node.textContent = Number(count);
    });
  };

  const syncCount = () => {
    if (!window.routes?.cart_url) return;
    fetch(`${window.routes.cart_url}.js`)
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => {
        if (cart) setCount(cart.item_count);
      })
      .catch(() => {});
  };

  const openCart = (trigger) => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(trigger);
      return;
    }
    window.location.href = window.routes?.cart_url || '/cart';
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(triggerSelector);
    if (!trigger) return;
    event.preventDefault();
    openCart(trigger);
  });

  document.addEventListener('keydown', (event) => {
    const trigger = event.target.closest(triggerSelector);
    if (!trigger || event.code.toUpperCase() !== 'SPACE') return;
    event.preventDefault();
    openCart(trigger);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.cartData?.item_count != null) {
        setCount(event.cartData.item_count);
        return;
      }
      syncCount();
    });
  }

  document.addEventListener('DOMContentLoaded', syncCount, { once: true });
})();
